import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import AdminLayout from "./AdminLayout";
import ErrorToast from "./Errors/ErrorToast";

// This interesting component redirects the User to a log in page if they are not authenticated.
const AdminRoute = ({ component: Component, isAuthenticated, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return isAuthenticated ? (
          <AdminLayout>
            <ErrorToast />
            <Component {...props} />
          </AdminLayout>
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { redirect: props.location },
            }}
          />
        );
      }}
    />
  );
};

const mapState = (state) => {
  return { isAuthenticated: state.auth.isAuthenticated };
};

export default withRouter(connect(mapState)(AdminRoute));
